import * as Lockr from 'lockr';
import without = require('lodash/without'); // tslint:disable-line: no-require-imports

import {
	AUTHENTICATE__ACTIONTYPES,
	LOGOUT__ACTIONTYPE,
	CLEAR_AUTHENTICATION__ACTIONTYPE,
	DISPLAY_ERROR__ACTIONTYPE,
	DISMISS_ERROR__ACTIONTYPE,
	RENEW_AUTHENTICATION__ACTIONTYPES,
} from '../../constants/global';
import {redirectToHome, redirectToLoggedOut} from '../../../history';
import {shouldLogOutOnFailure, limitAuthenticationErrorsFlashed, clearAuthenticationErrors} from '../util';

const USER_KEY = 'config_studio_user';

const INITIAL_USER: UserState = {
	username: null,
	authorization: null,
};

function getInitialUser(): UserState {
	return Lockr.get<UserState>(USER_KEY, INITIAL_USER);
}

const INITIAL_STATE: GlobalState = {
	user: getInitialUser(),
	loading: [],
	errors: [],
};

function saveState(nextState: GlobalState): GlobalState {
	Lockr.set(USER_KEY, nextState.user);
	return nextState;
}

function redirectAsNeeded(action: Action) {
	if (
		action.type === 'ASYNC_SUCCESS'
		&& action.successReference === AUTHENTICATE__ACTIONTYPES.SUCCESS
	) {
		redirectToHome();
	} else if (
		action.type === 'ASYNC_FAILURE'
		&& shouldLogOutOnFailure(action)
	) {
		redirectToLoggedOut();
	} else if (
		action.type === CLEAR_AUTHENTICATION__ACTIONTYPE
		|| action.type === LOGOUT__ACTIONTYPE
	) {
		redirectToLoggedOut();
	}
}

function handleAsyncSuccess(state: GlobalState, action: AsyncSuccessAction): GlobalState {
	const loading = without(state.loading, action.asyncSuccessData.requestId);
	if (action.successReference === AUTHENTICATE__ACTIONTYPES.SUCCESS) {
		return saveState({
			user: {...action.asyncSuccessData.data},
			loading,
			errors: clearAuthenticationErrors(state.errors),
		});
	} else if (action.successReference === RENEW_AUTHENTICATION__ACTIONTYPES.SUCCESS) {
		return saveState({
			...state,
			user: {...state.user, authorization: action.asyncSuccessData.data},
		});
	} else {
		return saveState({
			...state,
			loading,
		});
	}
}

function handleAsyncFailure(state: GlobalState, action: AsyncFailureAction): GlobalState {
	const loading = without(state.loading, action.asyncFailureData.requestId);
	if (action.failureReference === AUTHENTICATE__ACTIONTYPES.FAILURE) {
		return saveState({
			...state,
			loading,
		});
	} else if (shouldLogOutOnFailure(action)) {
		return saveState({
			...state,
			user: INITIAL_USER,
			loading,
		});
	} else {
		return saveState({
			...state,
			loading,
		});
	}
}

export default function global(
	state: GlobalState = INITIAL_STATE,
	action: Action,
): GlobalState {
	redirectAsNeeded(action);
	if (action.type === DISPLAY_ERROR__ACTIONTYPE) {
		return saveState({
			user: state.user,
			loading: state.loading,
			errors: limitAuthenticationErrorsFlashed(state.errors.concat(action.displayErrorData.error)),
		});
	} else if (action.type === DISMISS_ERROR__ACTIONTYPE) {
		return saveState({
			user: state.user,
			loading: state.loading,
			errors: without(state.errors, action.dismissErrorData.error),
		});
	} else if (action.type === LOGOUT__ACTIONTYPE) {
		return saveState({
			...state,
			user: INITIAL_USER,
		});
	} else if (action.type === CLEAR_AUTHENTICATION__ACTIONTYPE) {
		return saveState({
			user: INITIAL_USER,
			loading: state.loading,
			errors: state.errors.concat(action.error),
		});
	} else if (action.type === 'ASYNC_REQUEST') {
		return saveState({
			user: state.user,
			loading: state.loading.concat(action.asyncRequestData.requestId),
			errors: state.errors,
		});
	} else if (action.type === 'ASYNC_SUCCESS') {
		return handleAsyncSuccess(state, action);
	} else if (action.type === 'ASYNC_FAILURE') {
		return handleAsyncFailure(state, action);
	} else {
		return state;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/reducers/global/index.ts